import { Loading } from '@roo/roo'
import React from 'react'
import styles from './index.module.less'


const LoadingIcon = () => (
  <div style={{ width: '20px', height: '20px', display: 'inlineBlock' }}>
    <Loading visible size={'small'} text={''} iconType="circle" className={styles.loadingIcon}/>
  </div>
)
export default LoadingIcon